import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ReportTemplateService from '../../../Services/ReportTemplateService';
import ReportTemplateParameters from './ReportTemplateParameters';

const parameterTypeSelectValues = [
  { label: 'Choose one...', value: '', disabled: true },
  { label: 'Required', value: '1', disabled: false },
  { label: 'Optional', value: '2', disabled: false },
  { label: 'Disabled', value: '3', disabled: false },
];

export default class AddNewReportWindowDescription {
  static titleForCreate = 'Create New Report Template';
  static finishButtonLabel = 'Create Report Template';
  static messageOnSuccess = 'Report template has been created.';
  // ReportTemplateParameters's constructor self-populates UserId from the logged-in user
  // (via AuthService), so the wizard's default `new itemType()` seeding is sufficient here.
  static itemType = ReportTemplateParameters;

  // Preserves the old AddNewReportPanel.onSubmit FormData shape exactly. MUST return the
  // promise (wizard contract).
  static serviceFunction = (edited) => {
    const data = new FormData();
    data.append('file', edited.selectedFile);
    data.append('Name', edited.Name);
    data.append('OfficeParameterType', edited.OfficeParameterType);
    data.append('ClientParameterType', edited.ClientParameterType);
    data.append('ProjectParameterType', edited.ProjectParameterType);
    data.append('UserId', (edited.UserId ?? '').toString());
    return ReportTemplateService.postReportTemplateFile(data);
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'Report Template',
      fields: [
        {
          fieldName: 'Name',
          label: 'Report Name',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'selectedFile',
          label: 'Report Template File',
          className: 'col-4',
          type: InputTypesEnum.FileUploadField,
          acceptedTypes: '.xls, .xlsx',
          validityChecker: ValidityHelper.forRequiredFileField,
        },
        {
          fieldName: 'OfficeParameterType',
          label: 'Office Parameter Type',
          className: 'col-4',
          type: InputTypesEnum.Select,
          selectvalues: parameterTypeSelectValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ClientParameterType',
          label: 'Client Parameter Type',
          className: 'col-4',
          type: InputTypesEnum.Select,
          selectvalues: parameterTypeSelectValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ProjectParameterType',
          label: 'Project Parameter Type',
          className: 'col-4',
          type: InputTypesEnum.Select,
          selectvalues: parameterTypeSelectValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];
}
